import { http } from '@/lib/http';
import type {
  BarcodeRecord,
  BarcodeStatus,
  GenerateBarcodesPayload,
  GenerateBarcodesResult,
  ValidateScanPayload,
  ValidateScanResult,
} from '@/types/barcodes';

const BASE = '/api/v1/barcodes';

export interface BarcodeListQuery {
  itemId?: string;
  finishedGoodId?: string;
  status?: BarcodeStatus;
  code?: string;
  page?: number;
  pageSize?: number;
}

interface BarcodeListResponse {
  rows: BarcodeRecord[];
  page: number;
  pageSize: number;
  total: number;
}

export const barcodesService = {
  list: (query: BarcodeListQuery = {}) =>
    http.get<BarcodeListResponse>(BASE, { params: query }),
  /** Look up a single code (tenant-scoped). */
  get: (code: string) => http.get<BarcodeRecord>(`${BASE}/${encodeURIComponent(code)}`),
  /** Bulk pre-allocation: mint N codes optionally pre-bound to a SKU. */
  generate: (payload: GenerateBarcodesPayload) =>
    http.post<GenerateBarcodesResult, GenerateBarcodesPayload>(`${BASE}/generate`, payload),
  /** Context-aware scan validation (used by inward / dispatch / return flows). */
  validateScan: (payload: ValidateScanPayload) =>
    http.post<ValidateScanResult, ValidateScanPayload>(`${BASE}/validate-scan`, payload),
};
